<mat-card appearance="outlined" *ngIf="application">
  <mat-card-header>
    <mat-card-title>
      {{application.name}} Metadata Definitions
    </mat-card-title>
    <mat-card-subtitle>
      <button class="mx-1" mat-stroked-button color="accent" (click)="exportMetadata()">Export Metadata</button>
      <button class="mx-1" mat-stroked-button color="accent" (click)="importMetadata()">Import Metadata</button>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    <mat-table [dataSource]="dataSource">
      <!-- Name Column -->
      <ng-container matColumnDef="keyName">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-form-field floatLabel="{{ row.editing ? 'float' : 'never'}}">
            <input name="{{row.id}}-keyName" noWhitespace="input" [(ngModel)]="row.currentData.keyName"
              [readonly]="!row.editing" matInput>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="keyType">
        <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-form-field floatLabel="{{ row.editing ? 'float' : 'never'}}">
            <mat-select name="{{row.id}}-keyType" [(ngModel)]="row.currentData.keyType" [disabled]="!row.editing">
              <mat-option [value]="type.title" *ngFor="let type of typeList">
                {{type.title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Value Column -->
      <ng-container matColumnDef="keyDefault">
        <mat-header-cell *matHeaderCellDef> Default Value </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-form-field floatLabel="{{ row.editing ? 'float' : 'never'}}">
            <div [ngSwitch]="row.currentData.keyType">
              <div *ngSwitchCase="'DateTime'">
                <input name="{{row.id}}" [(ngModel)]="row.currentData.keyDefault" [readonly]="!row.editing" matInput
                  [matDatepicker]="tablepicker">
                <mat-datepicker-toggle matSuffix [for]="tablepicker" [hidden]="!row.editing"></mat-datepicker-toggle>
                <mat-datepicker #tablepicker disabled="false"></mat-datepicker>
              </div>
              <div *ngSwitchCase="'Text'">
                <input name="{{row.id}}" [(ngModel)]="row.currentData.keyDefault" [readonly]="!row.editing" matInput>
              </div>
              <div *ngSwitchCase="'Value'">
                <input type="number" name="{{row.id}}" [(ngModel)]="row.currentData.keyDefault"
                  [readonly]="!row.editing" matInput>
              </div>
              <div *ngSwitchDefault>
                <input name="{{row.id}}" [(ngModel)]="row.currentData.keyDefault" [readonly]="!row.editing" matInput>
              </div>
            </div>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actionsColumn">
        <mat-header-cell *matHeaderCellDef>
          <button mat-icon-button color="accent" (click)="dataSource.createNew()" matTooltip="Create new definition.">
            <mat-icon>add</mat-icon>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button *ngIf="!row.editing" mat-icon-button color="primary" focusable="false" (click)="startEditConfirm(row)"
            matTooltip="Edit value.">
            <mat-icon>create</mat-icon>
          </button>
          <button *ngIf="row.editing" mat-icon-button color="primary" focusable="false"
            (click)="createOrEditConfirm(row)" matTooltip="Save edit.">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button color="primary" focusable="false" (click)="cancelOrDeleteConfirm(row)"
            [matTooltip]="row.editing ? 'Cancel edit.' : 'Delete definition.'">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

  </mat-card-content>
</mat-card>